import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import SubBasestationBody from './SubBasestationBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import SubBasestationProvider from './provider/SubBasestationProvider';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const SubBasestation = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <SubBasestationProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="Sub Basestation" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <div className="container">
                  <SubBasestationBody />
                </div>
              </div>
            </div>
          </div>
        </main>
      </SubBasestationProvider>
      <ToastContainer />
    </div>
  );
};

export default SubBasestation;
